
import { Component, Vue } from 'vue-property-decorator'
import MobileView from '@/components/busi/custom/mobile-view.vue'
import Base from './infos/base.vue'
import util from '@/utils/busi/util'
import Detail from './infos/detail.vue'
import GradeSubject from './infos/gradesubject.vue'
import Standard from './infos/standard.vue'
import { schoolIntroduceDetail, schoolDetailDetail, schoolDetailUpdate, schoolIntroduceInsert, getGradeSubjectListNoPage } from '@/api/enrollmentinformation'
import { checkPermission } from '@/utils/permission'

@Component({
  name: 'dataset',
  components: {
    MobileView,
    Base,
    GradeSubject,
    Detail,
    Standard
  }
})
export default class DataSet extends Vue {
  private activeName = 'GradeSubject'

  private changeFlag = !1

  get readOnly () {
    return this.form.flag === 'edit'
  }

  get lbGradeSubjectList () {
    return checkPermission(['lbGradeSubjectList'])
  }

  private async handleClick () {
    if (this.activeName !== 'GradeSubject' && this.readOnly) {
      await getGradeSubjectListNoPage({
        schoolId: this.form.schoolId
      }).then(async (v: any) => {
        if (v.code === 10000) {
          if (v.object.list.length === 0) {
            this.$alert('请先配置保存年级专业数据', { type: 'error' })
            this.activeName = 'GradeSubject'
          }
        }
      })
    }
  }

  private data:any = {}

  private dataIntroduce:any = []

  private form = util.getRouterParams()

  private baseInfos: any = [
    {
      label: '院校名称',
      value: this.form.schoolName
    },
    {
      label: '学习类型',
      value: this.form.studyName
    },
    {
      label: '业务类型',
      value: this.form.businessName
    }
  ]

  private async getschoolDetailDetail (schoolId: any) {
    const temp = {
      content: '',
      createId: '',
      createName: '',
      createTime: '',
      degree: '',
      degreeName: '',
      degrees: '',
      flag: '',
      hotNum: '',
      hotSubject: '',
      hotSubjectName: '',
      hotSubjects: '',
      id: '',
      label: '',
      labelName: '',
      labels: '',
      logo: '',
      memo: '',
      proxyId: '',
      proxyName: '',
      schoolId: '',
      schoolName: '',
      seqType: '',
      state: '',
      updateId: '',
      updateName: '',
      updateTime: '',
      userId: '',
      version: '',
      forecast: '', // 预报名入口 （0：关闭，1：开启）
      entrance: '', // 入场券申请 （0：关闭，1：开启）
      endTime: ''
    }
    await schoolDetailDetail({
      schoolId: schoolId
    }).then((res: any) => {
      if (res.object) {
        const selects = {
          degrees: res.object.degree ? res.object.degree.split(',').map((v: any) => v * 1) : [],
          hotSubjects: res.object.hotSubject ? res.object.hotSubject.split(',').map((v: any) => v * 1) : [],
          labels: res.object.label ? res.object.label.split(',') : [],
          logo: res.object.logo ? res.object.logo : '',
          endTime: res.object.endTime ? res.object.endTime * 1 - (24 * 60 * 60 * 1000 - 1) : ''
        }
        this.data = Object.assign(temp, res.object, selects, { schoolName: this.form.schoolName, flag: this.form.flag })
      } else {
        this.data = Object.assign(temp)
      }
      if (!this.data || !this.data.logo) {
        this.data.state = 1
        this.data.forecast = 1
        this.data.entrance = 0
      }
    })
  }

  private async getSchoolIntroduceDetail (schoolId: any) {
    await schoolIntroduceDetail({
      schoolId: schoolId
    }).then((res: any) => {
      if (res.object) {
        // this.dataIntroduce = res.object
        this.dataIntroduce = res.object
        for (let i = 0; i < 9; i++) {
          let exists = !1
          for (let j = 0, data = res.object; j < data.length; j++) {
            if (data[j].titleType === i + 1) {
              exists = !0
            }
          }
          if (!exists) {
            const seq = this.dataIntroduce.length + 1
            this.dataIntroduce.push({
              content: '',
              createId: '',
              createName: '',
              createTime: new Date().getDate(),
              id: this.form.detailId,
              memo: '',
              modelType: '1',
              modelTypeName: '',
              schoolId: schoolId,
              seq: seq,
              subtitle: '',
              title: '',
              titleType: seq,
              titleTypeName: '',
              updateId: '',
              updateName: '',
              updateTime: '',
              version: '',
              att: []
            })
          }
        }
        // this.dataIntroduce = res.object
      }
    })
  }

  // @Watch('form.schoolId', { immediate: !0 })
  // private dataChange (val: any) {
  //   const schoolId = val
  //   if (!schoolId) return
  //   this.getschoolDetailDetail(schoolId)
  //   this.getSchoolIntroduceDetail(schoolId)
  // }

  beforeMount () {
    this.initData()
  }

  private async initData () {
    const schoolId = this.form.schoolId
    if (!schoolId) return
    await this.getschoolDetailDetail(schoolId)
    await this.getSchoolIntroduceDetail(schoolId)
  }

  private onBack () {
    this.$router.push({
      name: 'BriefContents'
    })
  }

  private async onPreView () {
    // if (this.activeName === 'Base') {
    //   const da = EnrollmentinformationModule.data;
    //   (this.$refs.mobile as any).updateData()
    //   // this.getschoolDetailDetail(this.data.schoolId)
    // } else {
    //   // this.getSchoolIntroduceDetail(this.data.schoolId)
    //   const da = EnrollmentinformationModule.dataIntroduce;
    //   (this.$refs.mobile as any).updateDataTnstrs()
    // }
  }

  private async onSave () {
    if (this.activeName === 'Base') {
      (this.$refs.base as any).validate(async () => {
        const data = {
          // id: this.form.detailId,
          schoolId: this.form.schoolId,
          title: this.data.title,
          goal: this.data.goal,
          logo: this.data.logo,
          content: this.data.content,
          // peopleNum: this.data.peopleNum,
          hotNum: this.data.hotNum,
          state: this.data.state,
          degree: this.data.degrees && this.data.degrees.length > 0 ? this.data.degrees.join(',') : '',
          hotSubject: this.data.hotSubjects && this.data.hotSubjects.length > 0 ? this.data.hotSubjects.join(',') : '',
          label: this.data.labels && this.data.labels.length > 0 ? this.data.labels.join(',') : '',
          forecast: this.data.forecast,
          entrance: this.data.entrance,
          endTime: this.data.endTime
        }
        if (!data.logo || !data.content || !data.goal || !data.title || !data.degree || !data.hotSubject || !data.label || (data.entrance && !data.endTime)) {
          this.$message.error('请完整输入数据')
          return
        }
        // if (!Number.isInteger(data.peopleNum)) {
        //   this.$message.error('招生人数，请输入数字值！')
        //   return
        // }
        await getGradeSubjectListNoPage({
          schoolId: this.form.schoolId
        }).then(async (v: any) => {
          if (v.code === 10000) {
            if (v.object.list.length === 0) {
              this.$alert('请先配置保存年级专业数据', { type: 'error' })
              return
            }
            data.endTime = data.entrance ? data.endTime * 1 + (24 * 60 * 60 * 1000 - 1) : ''
            await schoolDetailUpdate({
              ...data
            }).then((res: any) => {
              if (res.code === 10000) {
                this.$message(res.message)
              }
            })
          }
        })
      })
    } else {
      await schoolDetailDetail({
        schoolId: this.form.schoolId
      }).then(async (res: any) => {
        if (res.code === 10000) {
          if (!res.object || !res.object.logo) {
            this.$alert('请先配置基础信息', { type: 'error' })
            return
          }
          if (this.validateIntroduce(this.dataIntroduce)) {
            this.$alert('存在不完整的内容，请填写该模块的主标题')
            return
          }
          await schoolIntroduceInsert([
            ...this.dataIntroduce
          ]).then((res: any) => {
            if (res.code === 10000) {
              this.$message(res.message)
            }
          })
        }
      })
    }
  }

  private validateIntroduce (list: any) {
    if (!list || list.length === 0) return !1
    let flag = !1
    list.map((v: any) => {
      if (!v.title && (v.subtitle || v.content || (v.att && v.att.length > 0))) flag = !0
    })
    return flag
  }
}
